// this files contains shared constants used throughout the app

// NOTE: THESE MUST START WITH 'REACT_APP'!!!!!!!
// otherwise they will not get picked up by env-cmd

// google maps
const GOOGLE_MAPS_NAV_LINK = 'https://www.google.com/maps/dir/?api=1&destination=';

// server endpoint from env
let endpoint = '';
if (process.env.REACT_APP_SERVER_ENDPOINT) {
  endpoint = process.env.REACT_APP_SERVER_ENDPOINT; // dev or prod
} else {
  endpoint = 'http://127.0.0.1:8000'; // local
}
const SERVER_ENDPOINT = endpoint;

// client id from env
let clientId = '';
if (process.env.REACT_APP_CLIENT_ID) {
  clientId = process.env.REACT_APP_CLIENT_ID;
}
const CLIENT_ID = clientId;

// client secret from env
let clientSecret = '';
if (process.env.REACT_APP_CLIENT_SECRET) {
  clientSecret = process.env.REACT_APP_CLIENT_SECRET;
}
const CLIENT_SECRET = clientSecret;

// media endpoint for s3
let rawEndpoint = '';
if (process.env.REACT_APP_S3_ENDPOINT) {
  rawEndpoint = process.env.REACT_APP_S3_ENDPOINT;
}
const RAW_ENDPOINT = rawEndpoint;
const MEDIA_ENDPOINT = rawEndpoint.slice(0, rawEndpoint.length - 1) + '-resized/';

let recaptchaSitekey = '';
if (process.env.REACT_APP_RECAPTCHA_SITEKEY) {
  recaptchaSitekey = process.env.REACT_APP_RECAPTCHA_SITEKEY;
}
const RECAPTCHA_SITEKEY = recaptchaSitekey;

let eventbriteEndpoint = '';
if (process.env.REACT_APP_EVENTBRITE_ENDPOINT) {
  eventbriteEndpoint = process.env.REACT_APP_EVENTBRITE_ENDPOINT;
}
const EVENTBRITE_ENDPOINT = eventbriteEndpoint;

let eventbriteToken = '';
if (process.env.REACT_APP_EVENTBRITE_TOKEN) {
  eventbriteToken = process.env.REACT_APP_EVENTBRITE_TOKEN;
}
const EVENTBRITE_TOKEN = eventbriteToken;

let organizationId = '';
if (process.env.REACT_APP_EVENTBRITE_ORGANIZATION_ID) {
  organizationId = process.env.REACT_APP_EVENTBRITE_ORGANIZATION_ID;
}
const EVENTBRITE_ORGANIZATION_ID = organizationId;

const EVENTBRITE_ORGANIZER_ID = '23279957917';

const EVENTBRITE_ORGANIZER_ENDPOINT = 'https://eventbrite.com/o/';

let googleMapsAPIKey = '';
if (process.env.REACT_APP_GOOGLE_MAPS_API_KEY) {
  googleMapsAPIKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
}
const GOOGLE_MAPS_API_KEY = googleMapsAPIKey;

const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;

export {
  SERVER_ENDPOINT,
  GOOGLE_MAPS_NAV_LINK,
  CLIENT_ID,
  CLIENT_SECRET,
  RAW_ENDPOINT,
  MEDIA_ENDPOINT,
  RECAPTCHA_SITEKEY,
  EVENTBRITE_ENDPOINT,
  EVENTBRITE_TOKEN,
  EVENTBRITE_ORGANIZER_ID,
  EVENTBRITE_ORGANIZER_ENDPOINT,
  EVENTBRITE_ORGANIZATION_ID,
  GOOGLE_MAPS_API_KEY,
  PUBLIC_URL,
};
